module.exports = __webpack_public_path__ + "static/media/veradigm-logo.b8f99106.png";